import * as React from "react";
import type { SVGProps } from "react";
const SvgAiSparklesBtn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 32 32" {...props}
  >
    <rect width={32} height={32} fill="url(#ai-sparkles-btn_svg__a)" rx={16} />
    <path
      fill="url(#ai-sparkles-btn_svg__b)"
      d="M21.556 18.236c-4.754 1.11-5.893 2.254-6.969 7.098-.049.221-.398.221-.447 0-1.076-4.844-2.215-5.987-6.969-7.098-.228-.053-.228-.348 0-.401 4.754-1.11 5.894-2.254 6.969-7.097.049-.223.398-.223.447 0 1.076 4.843 2.215 5.986 6.969 7.097.228.053.228.348 0 .401"
    />
    <path
      fill="url(#ai-sparkles-btn_svg__c)"
      d="M24.943 14.038c-1.585.403-1.965.819-2.323 2.58-.016.081-.133.081-.15 0-.358-1.761-.737-2.177-2.322-2.58a.075.075 0 0 1 0-.146c1.585-.404 1.964-.82 2.323-2.581.016-.081.133-.081.15 0 .358 1.761.738 2.177 2.322 2.58.076.02.076.127 0 .146"
    />
    <path
      fill="url(#ai-sparkles-btn_svg__d)"
      d="M20.852 9.287c-1.584.404-1.964.82-2.323 2.581-.016.08-.133.08-.149 0-.358-1.761-.738-2.177-2.323-2.58a.075.075 0 0 1 0-.147c1.585-.403 1.965-.82 2.323-2.58.017-.081.133-.081.15 0 .358 1.76.738 2.177 2.322 2.58.076.02.076.127 0 .146"
    />
    <defs>
      <linearGradient
        id="ai-sparkles-btn_svg__a"
        x1={-10.406}
        x2={45.652}
        y1={21.953}
        y2={10.941}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#DEE8FF" />
        <stop offset={0.85} stopColor="#D9F3EE" />
      </linearGradient>
      <linearGradient
        id="ai-sparkles-btn_svg__b"
        x1={15}
        x2={18.5}
        y1={27.5}
        y2={2.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#0ACDA7" />
        <stop offset={0.85} stopColor="#0F53F2" />
      </linearGradient>
      <linearGradient
        id="ai-sparkles-btn_svg__c"
        x1={15}
        x2={18.5}
        y1={27.5}
        y2={2.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#0ACDA7" />
        <stop offset={0.85} stopColor="#0F53F2" />
      </linearGradient>
      <linearGradient
        id="ai-sparkles-btn_svg__d"
        x1={15}
        x2={18.5}
        y1={27.5}
        y2={2.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#0ACDA7" />
        <stop offset={0.85} stopColor="#0F53F2" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAiSparklesBtn;
